import React from 'react';

import { CHANGE_PASSWORD } from '@interlayer/js/app/components/main/ChangePassword/constants';

import { componentService } from 'js/services/component.service';

export const ChangePassword = React.lazy(() => import(/* webpackChunkName: "change-password" */ './ChangePassword'));

componentService.registerPageComponents({ [CHANGE_PASSWORD]: ChangePassword });
componentService.registerWebContentComponents({ ChangePassword });
